
   export class  JobEntity {
 /// define entity properties
} 
  